import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

import LogInModal from 'flarum/common/components/LogInModal';

export default class FreeResourceDirectoryListItem extends Component {
  createLogInModal() {
    return LogInModal;
  }
  view(vnode) {
    const { free_resource } = this.attrs;

    return (
      // <a href="" class="card">
      <Link
        className="free-resource"
        href={app.route.free_resource(free_resource.id())}
        onclick={(e) => {
          if (!app.session.user) {
            e.preventDefault();
            app.modal.show(this.createLogInModal());
          }
        }}
        target="_blank"
      >
        <div class="card-header">
          {free_resource.thumbnail()
            ? m('img', { src: app.forum.attribute('baseUrl') + '/' + free_resource.thumbnail(), alt: free_resource.title(), class: 'card__image' })
            : m('div', { class: 'empty-box' }, m('div', free_resource.title()))}
        </div>
        <div className={`card__overlay card-body ${app.translator.trans('td-free-resources.lib.type_classes.' + free_resource.type())}`}>
          <div>
            <h3>{free_resource.title()}</h3>
          </div>
        </div>
      </Link>
    );
  }
}
